import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import useSimpleTooltip from 'hooks/common/useSimpleTooltip';

import style from './QuestionMarkTooltip.module.scss';

const QuestionMarkTooltip = ({text, classes, markClasses}) => {
    const {tooltip, hoverFunctions} = useSimpleTooltip(text, cn(style.tooltip, classes.tooltip));
    const questionMarkStyles = cn(style.questionMark, markClasses);

    return (
        <div className={style.wrapper}>
            <div className={questionMarkStyles} {...hoverFunctions}>
                ?
            </div>
            {tooltip}
        </div>
    );
};

QuestionMarkTooltip.propTypes = {
    classes: PropTypes.shape({
        tooltip: PropTypes.string,
        wrapper: PropTypes.string,
        questionMark: PropTypes.string,
    }),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

QuestionMarkTooltip.defaultProps = {
    classes: {},
};

export default QuestionMarkTooltip;
